const SPRITEMAP_URL = '/build/app/img/symbols.svg';

export default function symbolUrl(name) {
    return `${SPRITEMAP_URL}#${name}`;
}
